import * as Api from '@ViewModels';
import { useEmailLikeStepSave, type UseEmailLikeStepSaveOverrides } from './useEmailLikeStepSave';
import type { useAutoSave } from './useAutoSave';

interface UseEmailStepSaveProps {
	emailStep: Api.IEmailAutomationStep | null;
	stepId: string | undefined;
	templateId: string | undefined;
	name: string;
	tagToAddOnClick: string;
	skipStepContactFilter: Api.IContactsFilterRequest | null | undefined;
	autoSave: ReturnType<typeof useAutoSave>;
}

/** Re-export the overrides type for callers. */
export type UseEmailStepSaveOverrides = UseEmailLikeStepSaveOverrides;

interface UseEmailStepSaveResult {
	save: (overrides?: UseEmailStepSaveOverrides) => Promise<void>;
}

/**
 * Save hook for EmailStepRenderer.
 * Delegates to the shared useEmailLikeStepSave hook.
 */
export function useEmailStepSave({
	emailStep,
	stepId,
	templateId,
	name,
	tagToAddOnClick,
	skipStepContactFilter,
	autoSave,
}: UseEmailStepSaveProps): UseEmailStepSaveResult {
	return useEmailLikeStepSave({
		step: emailStep,
		stepId,
		stepType: Api.AutomationStepType.Email,
		templateId,
		name,
		tagToAddOnClick,
		skipStepContactFilter,
		autoSave,
	});
}
